<template>
    <svg aria-hidden="true" focusable="false" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="19.5" stroke="#9D9FA2" />
        <path
            d="M25.037 15.9259C26.1007 15.9259 26.963 16.7882 26.963 17.8519C26.963 18.9155 26.1007 19.7778 25.037 19.7778M25.037 15.9259C23.9734 15.9259 23.1111 16.7882 23.1111 17.8519C23.1111 18.9155 23.9734 19.7778 25.037 19.7778M25.037 15.9259L25.037 14M25.037 19.7778L25.037 27"
            stroke="black"
            stroke-linecap="round" />
        <path
            d="M14.9259 15.9259C15.9896 15.9259 16.8519 16.7882 16.8519 17.8519C16.8519 18.9155 15.9896 19.7778 14.9259 19.7778M14.9259 15.9259C13.8623 15.9259 13 16.7882 13 17.8519C13 18.9155 13.8623 19.7778 14.9259 19.7778M14.9259 15.9259L14.9259 14M14.9259 19.7778L14.9259 27"
            stroke="black"
            stroke-linecap="round" />
        <path
            d="M20.2222 20.7407C21.2859 20.7407 22.1481 21.603 22.1481 22.6667C22.1481 23.7303 21.2859 24.5926 20.2222 24.5926M20.2222 20.7407C19.1586 20.7407 18.2963 21.603 18.2963 22.6667C18.2963 23.7303 19.1586 24.5926 20.2222 24.5926M20.2222 20.7407L20.2222 14M20.2222 24.5926L20.2222 27"
            stroke="black"
            stroke-linecap="round" />
    </svg>
</template>
